module.exports = __webpack_public_path__ + "img/222.eae69358.png";